///////////////////////////////////////////////
//! OverlayView 					 -------//
//////////////////////////////////////////////
OverlayView = function( dispatcher ) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------
	this.REPEAT = 0;
	this.DELAY = 0;
//--------------------------------------------
//! Vars
//--------------------------------------------
	this.dispatcher = dispatcher;

//////////////////////////////////////////////
	this.init();
//////////////////////////////////////////////

};

OverlayView.prototype = {


	constructor : OverlayView,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function ( ) {
		this.bindEvents();
		//this.createPlayer();
	},

    /*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/
	onShowEContent : function( event , data ){

		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE_EXTRA,  "_"+ data.title.copy );
		
		TweenMax.set( dom.exContent.wrapper, { opacity : 0 } );

		TweenMax.set( dom.exContent.media, { scale : 0, opacity : 0 } );

		this.animation.play( 0 );
		this.updateContent( data );
		
	},
	
	onHideEContent : function(event , data){
		TweenMax.set(dom.terms.micro, { y : 0} );
		TweenMax.set(dom.page.explore, { y : 0} );
		this.player.stopVideo();
		this.dispatcher.dispatch( EVENTS.UNMUTE_SOUND );
	},

	animationComplete : function(){

	},
	
	onTrailerState : function(playerStatus){
		
		if( playerStatus.data === 1 ) {
			this.dispatcher.dispatch( EVENTS.TRACKING_VIDEO, "extraContentVideo_"+ this.videoID );

			this.dispatcher.dispatch( EVENTS.MUTE_SOUND );
		}
		if( ( playerStatus.data === 0)||(playerStatus.data === 2) ) this.dispatcher.dispatch( EVENTS.UNMUTE_SOUND );
	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/
	createAnimation : function(){
		this.animation = new TimelineMax( { delay : 0, repeat : 0, onComplete : this.animationComplete , force3D : true} )
			.fromTo(dom.page.explore, 0.1 , { y : 0 }, {y:1000,ease : Power4.easeInOut},"page")
			.fromTo(dom.terms.micro, 0.1 , { y : 0 }, {y:1000,ease : Power4.easeInOut, force3D : true},"page")
			.fromTo( dom.exContent.wrapper, 0.3 , {  opacity:0 },{ opacity : 1 , force3D : true })
			//.set(dom.exContent.titles,{opacity:1,y : -100})
			.fromTo( dom.exContent.media, 0.6 , { scale : 0.8, opacity : 0 },{ scale : 1 ,opacity : 1 ,ease : Power4.easeInOut, force3D : true })
			.fromTo( dom.exContent.title, 0.6 , { opacity : 0 },{ opacity : 1,ease : Power4.easeInOut, force3D : true },"title")
			.fromTo( dom.exContent.text, 0.6 , { opacity : 0 },{ opacity : 1,ease : Power4.easeInOut, force3D : true },"title")
			.fromTo( dom.exContent.titles, 0.3, { y : -100},{ y : 0 ,ease : Power4.easeInOut, force3D : true },"end")
			.fromTo( dom.exContent.close, 0.3, { y : 100 },{ y : 0 ,ease : Power4.easeInOut , force3D : true },"end")
		this.animation.seek( 0 ).pause();	
	},
	
	createPlayer : function(id){
		this.videoID = id
		this.player = new YT.Player( dom.exContent.media_img.substring(1), {
			height : '600',
			width : '1200',
			videoId : id,
			playerVars : {
				playsinline : true,
				suggestedQuality : "hd720",
				fs : 0,
				showinfo : 0,
				modestbranding : 1,
				rel : 0,
			},
			events : {
				'onStateChange': this.onTrailerState.bind( this )
			}
		});
	},

	bindEvents : function ( ) {

		this.dispatcher.addEventListener( EVENTS.SHOW_EXTRA_CONTENTANIM, this.onShowEContent.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.UPDATE_OVERLAYANIM, this.createAnimation.bind( this ) );
		//this.dispatcher.addEventListener( EVENTS.SHOW_EXTRA_CONTENT, this.onShowEContent.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.CLOSE_OVERLAY, this.onHideEContent.bind( this ) );
		
	},
	
	updateContent : function(data){
		//Setup YOUTUBE OBJECT

		if( !this.player ) this.createPlayer( data.id );
		else {
		this.player.cueVideoById({videoId : data.id, suggestedQuality : "hd720" })
		this.videoID = data.id;
		}
		$( dom.exContent.title ).html( data.title.copy );
		$( dom.exContent.text ).html( data.text.copy );
	}

};
